<main id="main-content">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <h2 class="mb-1" i18n>En esta sección se podrán solicitar las autorizaciones correspondientes para cada
                    vehículo o consultar el estado de las autorizaciones solicitadas.</h2>
            </div>
            <div class="col-sm-12">
                <ul class="leyend">
                    <li><i class="bi bi-circle-fill small orange"></i> <span i18n>Solicitud enviada</span></li>
                    <li><i class="bi bi-exclamation-triangle-fill small orange"></i> <span i18n>Requerimiento datos
                            adicionales</span></li>
                    <li><i class="bi bi-circle-fill small blue"></i> <span i18n>Solicitud en revisión</span></li>
                    <li><i class="bi bi-circle-fill small green"></i> <span i18n>Solicitud aceptada</span></li>
                    <li><i class="bi bi-circle-fill small red"></i> <span i18n>Solicitud rechazada</span></li>
                    <li><i class="bi bi-circle-fill small black"></i> <span i18n>Solicitud expirada</span></li>
                </ul>
            </div>
            <div class="col-sm-12 mb-3">
                <p class="mb-1" i18n>Por una nueva autorización, primero debe dar de alta el vehículo y a continuación,
                    podrá seleccionar la autorización correspondiente.</p>
                <p class="mb-1" i18n>En caso de que quiera consultar el estado de su autorización, en detalle, haga clic
                    en el vehículo correspondiente.</p>
            </div>

            @for (vehicle of vehicles; track vehicle.vehiclePlate) {
            <div class="col-sm-6 col-md-4 col-lg-3 mb-3 vehicle-box" (click)="selectVehicle(vehicle)"
                [ngClass]="{'active': vehicleSelected?.vehiclePlate == vehicle.vehiclePlate || vehicleSelected == null}"
                *ngIf="vehicle.iconCategory">
                <app-vehicle-iccon-resume [vehicle]="vehicle" [showPending]="true"></app-vehicle-iccon-resume>
            </div>
            }
            <div class="col-sm-6 col-md-4 col-lg-3 mb-3" (click)="newVehicle()">
                <app-vehicle-iccon-resume></app-vehicle-iccon-resume>
            </div>
        </div>
        <div class="row mb-3" *ngIf="vehicles.length < total">
            <div class="col-12 text-center">
                <button type="button" class="btn btn-primary btn-rounded btn-full-width" (click)="loadMore()">
                    <span i18n>Cargar más</span>
                </button>
            </div>
        </div>
    </div>

    <div class="container" *ngIf="vehicleSelected">
        <div class="row mb-3">
            <div class="col-8 section-title-full">
                <h2>
                    <span i18n>Mis autorizaciones</span>: {{vehicleSelected.vehiclePlate}}
                </h2>
            </div>
            <div class="col-4 text-end">
                <button type="button" class="btn btn-danger btn-small btn-rounded" (click)="deleteVehicle()"
                    *ngIf="showDelete">
                    <i class="bi bi-trash small mr-3"></i> <span i18n>Eliminar vehiculo</span>
                </button>
            </div>
        </div>
    </div>

    <div class="container mb-3" id="vehicle-selected">
        <div class="row my-5" *ngIf="vehicleSelected">
            <div class="col-12 text-md-end mb-3" *ngIf="!haveExceptionsInProcess">
                <button type="button" class="btn btn-primary btn-rounded" (click)="newAutorization()">
                    <span i18n>Crear Solicitud</span>
                </button>
            </div>
            <div class="col-12">
                <div class="card accordion secondary" id="accordionCats">
                    <div *ngFor="let exception of exceptionsList; let i = index" class="accordion-item">
                        <h3 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                [attr.data-bs-target]="'#collapseC-' + i" aria-expanded="false"
                                [attr.aria-controls]="'collapseC-' + i">
                                <b>{{exception.vehiclePlate}}</b><span class="exception_name">{{exception.type.name}}
                                    [{{exception.timestamps.creationTimestamp.timestamp |
                                    date:'dd/MM/yyyy'}}]</span><app-status-tag [status]="exception.state"
                                    [simple]="true"></app-status-tag>
                            </button>
                        </h3>
                        <div id="collapseC-{{i}}" class="accordion-collapse collapse" data-bs-parent="#accordionCats">
                            <div class="row exception-container">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-8">
                                            <h2 class="my-4" i18n>Datos autorización</h2>
                                        </div>
                                        <div class="col-4 text-end">
                                            <button type="button" class="btn btn-danger btn-rounded btn-del-request"
                                                (click)="deleteAutorization(exception)"
                                                *ngIf="exception.state == 'Pending'">
                                                <i class="bi bi-trash small mr-3"></i>
                                                <span i18n>Eliminar Solicitud</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="row">
                                            <div class="col-md-4 mb-3">
                                                <label for="vehicle" class="form-label"><span i18n>Fecha de
                                                        creación</span>:</label>
                                                <p>{{exception.timestamps.creationTimestamp.timestamp |
                                                    date:'dd/MM/yyyy'}}
                                                </p>
                                            </div>
                                            <div class="col-md-4 mb-3">
                                                <label for="vehicle" class="form-label"><span i18n>Matrícula</span>:
                                                </label>
                                                <p>{{exception.vehiclePlate}}</p>
                                            </div>
                                            <div class="col-md-4 mb-3">
                                                <label for="vehicleType" class="form-label"><span i18n>Tipo de
                                                        autorización</span>: </label>
                                                <p>{{exception.type.name}}</p>
                                            </div>
                                            <div class="col-md-4 mb-3">
                                                <label for="vehicle" class="form-label"><span i18n>Número de
                                                        expediente</span>:</label>
                                                <p>{{exception.recordNumber}}</p>
                                            </div>
                                            <div class="col-md-4 mb-3">
                                                <label for="driver" class="form-label">
                                                    <span i18n>Nombre del solicitante</span>:
                                                </label>
                                                <p>{{exception.applicantName}}</p>
                                            </div>
                                            <div class="col-md-4 mb-3">
                                                <label for="driver" class="form-label">
                                                    <span i18n>DNI del solicitante</span>:
                                                </label>
                                                <p>{{exception.applicantIdentifier}}</p>
                                            </div>
                                            <div class="col-md-4 mb-3">
                                                <label for="driver" class="form-label">
                                                    <span i18n>Población</span>:
                                                </label>
                                                <p>{{exception.municipality}}</p>
                                            </div>
                                            <div class="col-md-4 mb-3">
                                                <label for="driver" class="form-label">
                                                    <span i18n>Fecha de Caducidad</span>:
                                                </label>
                                                <p>{{(exception.timestamps.validTo?.timestamp | date) ?? withoutCad}}
                                                </p>
                                            </div>
                                            <div class="col-md-4 mb-3">
                                                <label for="status" class="form-label"><span i18n>Estado</span>:
                                                </label>
                                                <p><app-status-tag [status]="exception.state"
                                                        [simple]="true"></app-status-tag></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" *ngIf="exception.type.code == 'VPMR' && exception.type_vpmr">
                                    <h2 class="my-4" i18n>Otros campos de la autorización</h2>
                                    <div class="card">
                                        <div class="row">
                                            <div class="col-12 mb-3">
                                                <div class="mb-1 check-legal">
                                                    <input class="form-check-input" type="checkbox"
                                                        [(ngModel)]="exception.type_vpmr.anotherPerson"
                                                        id="anotherPerson" disabled>
                                                    <label for="anotherPerson" class="form-label ml-3"><span i18n>Es otra persona</span></label>
                                                </div>
                                                <div class="col-sm-12 col-md-6 col-xl-4 mb-3">
                                                    <label for="nombre" class="form-label"><span
                                                            i18n>Nombre</span>:</label>
                                                    <p>{{exception.type_vpmr!.applicant?.name}}</p>
                                                </div>

                                                <div class="col-sm-12 col-md-6 col-xl-4 mb-3">
                                                    <label for="primer-apellido" class="form-label"><span i18n>Primer
                                                            apellido</span>:</label>
                                                    <p>{{exception.type_vpmr!.applicant?.firstSurname}}</p>
                                                </div>

                                                <div class="col-sm-12 col-md-6 col-xl-4 mb-3">
                                                    <label for="segundo-apellido" class="form-label"><span i18n>Segundo
                                                            apellido</span>:</label>
                                                    <p>{{exception.type_vpmr!.applicant?.secondSurname}}</p>
                                                </div>

                                                <div class="col-sm-12 col-md-6 col-xl-6 mb-3">
                                                    <label for="dni" class="form-label"><span i18n>Numero de documento
                                                            de identidad(NIF, NIE,
                                                            pasaporte)</span>:</label>
                                                    <p>{{exception.type_vpmr!.applicant?.documentIdentification}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" *ngIf="exception.type.code == 'MALALT' && exception.type_malalt">
                                    <h2 class="my-4" i18n>Otros campos de la autorización</h2>
                                    <div class="card">
                                        <div class="row">
                                            <!-- <div class="col-sm-12 col-md-6 col-xl-4 mb-3">
                                                <label for="nombre" class="form-label"><span i18n>Nombre</span>:</label>
                                                <input type="text" class="form-control" id="nombre"
                                                    [(ngModel)]="exception.type_malalt!.vehicleOwner.applicantIdentification.name">
                                            </div>
                        
                                            <div class="col-sm-12 col-md-6 col-xl-4 mb-3">
                                                <label for="primer-apellido" class="form-label"><span i18n>Primer
                                                        apellido</span>:</label>
                                                <input type="text" class="form-control" id="primer-apellido"
                                                    [(ngModel)]="exception.type_malalt!.vehicleOwner.applicantIdentification.firstSurname">
                                            </div>
                        
                                            <div class="col-sm-12 col-md-6 col-xl-4 mb-3">
                                                <label for="segundo-apellido" class="form-label"><span i18n>Segundo
                                                        apellido</span>:</label>
                                                <input type="text" class="form-control" id="segundo-apellido"
                                                    [(ngModel)]="exception.type_malalt!.vehicleOwner.applicantIdentification.secondSurname">
                                            </div>
                        
                                            <div class="col-sm-12 col-md-6 col-xl-6 mb-3">
                                                <label for="dni" class="form-label"><span i18n>Numero de documento de identidad(NIF, NIE,
                                                        pasaporte)</span>:</label>
                                                <input type="text" class="form-control" id="dni"
                                                    [(ngModel)]="exception.type_malalt!.vehicleOwner.applicantIdentification.documentIdentification">
                                            </div>
                        
                                            <div class="col-md-6 col-xl-6 mb-3">
                                                <label for="tsi" class="form-label"><span i18n>Número de tarjeta sanitaria individual
                                                        (TSI)</span>:</label>
                                                <input type="text" class="form-control" id="tsi" [(ngModel)]="exception.type_malalt!.TSI">
                                            </div> -->

                                            <div class="col-12 mb-3">
                                                <div>
                                                    <label class="form-label ml-3" i18n>El tipo de centro médico donde
                                                        se
                                                        realiza el tratamiento es:</label>
                                                    <p>{{getMedicalCenter(exception.type_malalt!.medicalCenter)}}</p>
                                                </div>
                                            </div>

                                            <div class="col-md-12 col-xl-12 mb-3"
                                                *ngIf="exception.type_malalt!.medicalCenter != ''
                                                && exception.type_malalt!.medicalCenter != 'Other centers outside the catalan public sector'">
                                                <label for="tsi" class="form-label"><span i18n>Número de tarjeta sanitaria individual (TSI)</span>:</label>
                                                <p>{{exception.type_malalt!.TSI}}</p>
                                            </div>

                                            <div class="col-12 mb-3">
                                                <div class="mb-1 check-legal">
                                                    <label class="form-label ml-3"><span i18n>Declaro bajo mi responsabilidad</span>:</label>
                                                </div>
                                                <div class="mb-1 check-legal">
                                                    <input class="form-check-input" type="checkbox"
                                                        [(ngModel)]="exception.type_malalt!.selfResponsibility"
                                                        id="selfResponsibility" disabled>
                                                    <label for="selfResponsibility"
                                                        class="form-label ml-3 label-checkbox"><span i18n>Estoy
                                                            diagnosticado/a de una enfermedad o tengo una discapacidad
                                                            reconocida que condiciona el uso del transporte público y
                                                            existe
                                                            una recomendación médica para no utilizar el transporte
                                                            público</span>.</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12"
                                    *ngIf="exception.type.code == 'MUNICIPAL' && exception.type_municipal">
                                    <h2 class="my-4" i18n>Otros campos de la autorización</h2>
                                    <div class="card">
                                        <div class="row">
                                            <div class="col-12 mb-3">
                                                <div class="row">
                                                    <div class="col-sm-12 col-md-6 mb-3">
                                                        <label for="tipo-evento" class="form-label"><span i18n>Tipo de
                                                                evento</span>:</label>
                                                        <p>{{getEventType(exception.type_municipal!.eventType)}}</p>
                                                    </div>
                                                    <div class="col-sm-12 col-md-6 mb-3">
                                                        <label for="descripcion" class="form-label" i18n>Descripción
                                                            acontecimiento:</label>
                                                        <p>{{exception.type_municipal!.description}}</p>
                                                    </div>
                                                    <div class="col-sm-12 col-md-6 mb-3">
                                                        <label for="fecha-inicio" class="form-label" i18n>Fecha de
                                                            inicio:</label>
                                                        <p>{{exception.type_municipal.from.timestamp| date:'dd/MM/yyyy'}}</p>
                                                    </div>
                                                    <div class="col-sm-12 col-md-6 mb-3">
                                                        <label for="fecha-fin" class="form-label" i18n>Fecha de
                                                            fin:</label>
                                                        <p>{{exception.type_municipal.to.timestamp| date:'dd/MM/yyyy'}}</p>
                                                    </div>
                                                    <!-- <div class="col-sm-12 col-md-6 mb-3">
                                                        <label for="provincia" class="form-label"><span
                                                                i18n>Provincia</span>:</label>
                                                        <p>{{exception.type_municipal!.address?.province}}</p>
                                                    </div>

                                                    <div class="col-sm-12 col-md-6 mb-3">
                                                        <label for="municipio" class="form-label"><span
                                                                i18n>Municipio</span>:</label>
                                                        <p>{{exception.type_municipal!.address?.municipality}}</p>
                                                    </div> -->
                                                    <div class="col-sm-6 col-xl-3 mb-3" *ngIf="exception.type_municipal!.address">
                                                        <label for="stret-type" class="form-label"><span i18n>Tipo de
                                                                vía</span>:</label>
                                                        <p>{{exception.type_municipal!.address.streetTypeName}}</p>
                                                    </div>
                                                    <div class="col-sm-6 col-xl-6 mb-3">
                                                        <label for="nombre-via" class="form-label"><span i18n>Nombre de
                                                                vía</span>:</label>
                                                        <p>{{exception.type_municipal!.address?.streetName}}</p>
                                                    </div>
                                                    <div class="col-sm-6 col-xl-3 mb-3">
                                                        <label for="numero" class="form-label"><span
                                                                i18n>Número</span>:</label>
                                                        <p>{{exception.type_municipal!.address?.streetNumber}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" *ngIf="exception.type.code == 'PROF' && exception.type_prof">
                                    <h2 class="my-4" i18n>Otros campos de la autorización</h2>
                                    <div class="card">
                                        <div class="row">
                                            <div class="col-12 mb-1">
                                                <div class="mb-1 check-legal">
                                                    <input class="form-check" type="checkbox"
                                                        [(ngModel)]="exception.type_prof!.selfResponsibility"
                                                        id="selfResponsibility" disabled>
                                                    <label for="selfResponsibility" class="ml-3"><span i18n>Declaro que
                                                            este vehículo constituye
                                                            un instrumento necesario para el ejercicio de mi actividad
                                                            profesional.</span></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" *ngIf="exception.type.code == 'SALARY' && exception.type_salary">
                                    <h2 class="my-4" i18n>Otros campos de la autorización</h2>
                                    <div class="card">
                                        <div class="row">
                                            <div class="col-12 mb-3">
                                                <div class="mb-1 check-legal">
                                                    <input class="form-check-input" type="checkbox"
                                                        [(ngModel)]="exception.type_salary!.hasRelation"
                                                        id="has-relation" disabled>
                                                    <label for="has-relation" class="form-label ml-3 label-checkbox"
                                                        i18n>Tiene cónyuge o relación análoga</label>
                                                </div>
                                                <div class="col-12 mb-3" *ngIf="exception.type_salary!.hasRelation">
                                                    <label for="estado-civil" class="form-label"><span i18n>Estado
                                                            civil</span>:</label>
                                                    <p>{{getCivilState(exception.type_salary!.civilState)}}</p>
                                                </div>
                                                <div class="col-12 mb-3">
                                                    <label for="unidad-familiar" class="form-label"><span i18n>Unidad
                                                            Familiar</span>:</label>
                                                    <p>{{exception.type_salary!.family}}</p>
                                                </div>
                                                <div class="col-12 mb-3">
                                                    <p i18n>Son miembros de la unidad familiar la persona solicitante,
                                                        el
                                                        cónyuge o la persona con la que mantenga una relación análoga de
                                                        afectividad y las personas menores de 25 años.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <h2 class="my-4" i18n>Estados</h2>

                                    <div class="card">
                                        <div class="col-12">
                                            <div class="states-box">
                                                <div class="message" *ngFor="let state of exception.states"
                                                    [ngClass]="state.ticket.sourceProfile"
                                                    [ngStyle]="{'background-color': state.ticket.background, 'color': state.ticket.foreground}">
                                                    <p>{{state.ticket.sourceUser}}</p>
                                                    <p>{{state.ticket.observations}}</p>
                                                    <span>{{state.timestamp.timestamp | date:'dd/MM/yyyy HH:mm'}}</span>
                                                </div>
                                            </div>
                                            <div class="card send-observation"
                                                *ngIf="exception.state == 'Pending' || exception.state == 'Attention'">
                                                <div class="form-group mb-3">
                                                    <label for="observation" class="form-label"
                                                        i18n>Observaciones</label>
                                                    <textarea class="form-control" id="observation" rows="3"
                                                        [(ngModel)]="exception.observation"></textarea>
                                                </div>
                                                <div class="form-group">
                                                    <button type="button" class="btn btn-primary btn-rounded"
                                                        (click)="sendObservation(exception)" i18n>Enviar
                                                        comentario</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <h2 class="my-4" i18n>Ficheros</h2>

                                    <ul class="nav nav-tabs primary" [id]="'filesTabs'+exception.recordNumber"
                                        role="tablist">
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link active" [id]="'my-files'+exception.recordNumber"
                                                data-bs-toggle="tab"
                                                [attr.data-bs-target]="'#my-files-tab'+exception.recordNumber"
                                                type="button" role="tab" aria-controls="my-files-tab"
                                                aria-selected="true" i18n>Documentos
                                                enviados</button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" [id]="'operator-files'+exception.recordNumber"
                                                data-bs-toggle="tab"
                                                [attr.data-bs-target]="'#operator-files-tab'+exception.recordNumber"
                                                type="button" role="tab" aria-controls="operator-files-tab"
                                                aria-selected="false" i18n>Documentos
                                                recibidos</button>
                                        </li>
                                    </ul>
                                    <div class="tab-content bordered" [id]="'filesTabContent'+exception.recordNumber">
                                        <div class="tab-pane fade show active"
                                            [id]="'my-files-tab'+exception.recordNumber" role="tabpanel" tabindex="0">
                                            <div class="col-12 mb-3"
                                                *ngIf="exception.state == 'Pending' || exception.state == 'Attention'">
                                                <label for="formFileMultiple" class="form-label"><span
                                                        i18n>Documentos</span>:
                                                </label>
                                                <div class="col-12 oh">
                                                    <app-custom-input-file
                                                        (onFileSelected)="addFiles($event, exception)"
                                                        *ngIf="reloadFiles"></app-custom-input-file>
                                                </div>
                                                <div class="col-12">
                                                    <small i18n>Tamaño de fichero máximo de 5MB</small>
                                                </div>
                                            </div>
                                            <div class="d-none d-md-block col-12">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col" i18n>Nombre</th>
                                                                <th scope="col" i18n>Tipo</th>
                                                                <th scope="col" i18n>Fecha</th>
                                                                <th class="col col-actions" scope="col" i18n>Acciones
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                *ngFor="let file of exception.attachments; let i = index">
                                                                <td>{{file.name}}</td>
                                                                <td>{{file.mime}}</td>
                                                                <td>{{file.timestamp?.timestamp | date}}</td>
                                                                <td class="col col-actions">
                                                                    <button type="button"
                                                                        class="btn btn-outline-primary btn-icon"
                                                                        (click)="downloadFile(file, exception)"
                                                                        aria-label="Descargar adjunto"
                                                                        *ngIf="file.uuid"><i
                                                                            class="bi bi-download"></i></button>
                                                                    <button type="button"
                                                                        class="btn btn-outline-danger btn-icon"
                                                                        *ngIf="exception.state == 'Pending' || exception.state == 'Attention'"
                                                                        (click)="removeFile(i, exception)"
                                                                        aria-label="Eliminar adjunto"><i
                                                                            class="bi bi-trash3-fill"></i></button>
                                                                </td>
                                                            </tr>
                                                            <tr *ngIf="exception.attachments.length == 0">
                                                                <td colspan="4" class="text-center" i18n>No hay ficheros
                                                                </td>
                                                            </tr>
                                                    </table>
                                                </div>
                                            </div>
                                            <div class="d-block d-md-none col-12 mb-3">
                                                <div class="accordion secondary" id="accordionFiles">
                                                    <div *ngFor="let file of exception.attachments; let i = index"
                                                        class="accordion-item">
                                                        <h3 class="accordion-header">
                                                            <button class="accordion-button collapsed" type="button"
                                                                data-bs-toggle="collapse"
                                                                [attr.data-bs-target]="'#collapseF-' + i"
                                                                aria-expanded="false"
                                                                [attr.aria-controls]="'collapseF-' + i">
                                                                <b>{{file.name}}</b>
                                                            </button>
                                                        </h3>
                                                        <div id="collapseF-{{i}}" class="accordion-collapse collapse"
                                                            data-bs-parent="#accordionFiles">
                                                            <div class="row exception-container">
                                                                <div class="col-12">
                                                                    <div class="row">
                                                                        <p class="card-text mb-1"><span i18n>Tipo de
                                                                                fichero: </span>{{file.mime}}</p>
                                                                        <p class="card-text mb-1"><span i18n>Fecha de
                                                                                inclusión:
                                                                            </span>{{file.timestamp?.timestamp | date}}
                                                                        </p>
                                                                        <div class="col-6 text-center">
                                                                            <button type="button"
                                                                                class="btn btn-outline-primary button-text"
                                                                                (click)="downloadFile(file, exception)"
                                                                                aria-label="Descargar adjunto"
                                                                                *ngIf="file.uuid"><i
                                                                                    class="bi bi-download"></i></button>
                                                                        </div>
                                                                        <div class="col-6 text-center">
                                                                            <button type="button"
                                                                                class="btn btn-outline-danger button-text"
                                                                                (click)="removeFile(i, exception)"
                                                                                aria-label="Eliminar adjunto"><i
                                                                                    class="bi bi-trash3-fill"></i></button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 btn-actions"
                                                *ngIf="exception.state == 'Pending' || exception.state == 'Attention'">
                                                <button type="button" class="btn btn-primary btn-rounded"
                                                    (click)="saveFiles(exception)" i18n>Guardar</button>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" [id]="'operator-files-tab'+exception.recordNumber"
                                            role="tabpanel" tabindex="-1">
                                            <div class="d-none d-md-block col-12">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col" i18n>Nombre</th>
                                                                <th scope="col" i18n>Tipo</th>
                                                                <th scope="col" i18n>Fecha</th>
                                                                <th class="col col-actions" scope="col" i18n>Acciones
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                *ngFor="let file of exception.attachmentsOperator; let i = index">
                                                                <td>{{file.name}}</td>
                                                                <td>{{file.mime}}</td>
                                                                <td>{{file.timestamp?.timestamp | date}}</td>
                                                                <td class="col col-actions">
                                                                    <button type="button"
                                                                        class="btn btn-outline-primary btn-icon"
                                                                        (click)="downloadFile(file, exception)"
                                                                        aria-label="Descargar adjunto"
                                                                        *ngIf="file.uuid"><i
                                                                            class="bi bi-download"></i></button>
                                                                </td>
                                                            </tr>
                                                            <tr *ngIf="exception.attachmentsOperator.length == 0">
                                                                <td colspan="4" class="text-center" i18n>No hay ficheros
                                                                </td>
                                                            </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="exceptionsList.length == 0">
                        <b i18n>No hay solicitudes</b>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container"
        *ngIf="vehicleSelected && exceptionsList.length > 0 && vehicleSelected.exceptionState == 'Accepted'">
        <div class="row mb-3">
            <div class="col section-title-full">
                <h2 i18n>Listado de municipios a los que puedo acceder</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div *ngIf="!vehicleSelected.municipalities || vehicleSelected.municipalities.length == 0">
                    <p i18n>Actualmente no dispone del listado de municipios a los que puede acceder porque su
                        autorizacion
                        esta en tramite o pendiente.</p>
                </div>
                <div *ngIf="vehicleSelected.municipalities.length > 0">
                    <p i18n>Los miunicipios a los que puede acceder són:</p>
                    <ul>
                        <li *ngFor="let municipality of vehicleSelected.municipalities">{{municipality}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</main>